enum Cookies {
  PWA_NEXT_ENABLED = 'pwa-next-enabled',
  USER_IDENTIFIER_COOKIE_NAME = 'ha_anonymous_id',
  FEATURES = 'ha-feature-flags',
  ADVERTISER_REVIEWS_ANSWER = 'ha-advertiser-reviews-answer',
  RENT_RADAR_ANSWER = 'ha-rent-radar-answer',
  ADVANCED_PRICING_BANNER_SHOWN = 'advanced-pricing-banner-shown',
}

export default Cookies;
